import utils from "@/utils";

const VideoOptionMenu = [
  {
    title: "Report",
    icon: "mdi:flag",
    clickevent: ({ onReport, toggleLoginModal }) => {
      if (utils.isLogin()) {
        onReport();
      } else {
        toggleLoginModal();
      }
    },
  },
];

export default VideoOptionMenu;
